import {ucfirst} from "../plugins/uniweb";

/**
 * Class UserManager.js
 *
 * @class UserManager
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.11] app/src/manager/UserManager.js
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export class UserManager {
  constructor(authentication) {
    /** @type DashboardAuthenticationManager */
    this._authentication = authentication;
  }

  getUserFullName() {
    const tokenData = this._authentication.getTokenData()

    return tokenData.username ? tokenData.username.split('.').map((name) => ucfirst(name)).join(" ") : '';
  }
}